<template>
  <v-hover v-slot="{ hover }">
    <v-row :class="hover ? 'green lighten-5' : ''" align="center" class="py-1">
      <v-col cols="3">
        <div class="font-weight-medium">{{ fito.dettagli.prodotto }}</div>
        <div class="text-caption grey--text text-truncate">
          <v-icon x-small class="mr-1">mdi-pound</v-icon
          >{{ fito.dettagli.numero_registrazione }}
          <template v-if="fito.dettagli.impresa">
            <v-icon x-small class="ml-2 mr-1">mdi-domain</v-icon
            >{{ fito.dettagli.impresa }}
          </template>
        </div>
      </v-col>
      <v-col cols="2">
        <v-icon x-small class="mr-1" color="grey">mdi-flask-outline</v-icon
        >{{ fito.dettagli.sostanze_attive }}
      </v-col>
      <v-col cols="2">
        <v-chip :color="stato_chip_color" text-color="white" x-small>
          <v-icon left x-small>{{ stato_chip_icon }}</v-icon>
          {{ fito.dettagli.stato_amministrativo || "N/D" }}
        </v-chip>
      </v-col>
      <v-col cols="2" :class="scadenza_scaduta ? 'red--text' : ''">
        <v-icon
          x-small
          class="mr-1"
          :color="scadenza_scaduta ? 'red' : 'grey'"
          >mdi-calendar-alert</v-icon
        >{{ fito.dettagli.scadenza_autorizzazione }}
      </v-col>
      <v-col cols="1">
        <span :class="in_magazzino > 0 ? 'green--text' : 'red--text'"
          ><b>{{ in_magazzino.toFixed(1) }}</b></span
        >
        Kg/Lt.
      </v-col>
      <v-col cols="2">
        <v-tooltip top v-if="hover">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="blue"
              small
              class="mr-2 my-n2"
              v-bind="attrs"
              v-on="on"
              @click="dialog_movimenti = true"
              ><v-icon>mdi-swap-vertical</v-icon></v-btn
            >
          </template>
          <span>Storico movimenti</span>
        </v-tooltip>
        <v-dialog v-model="dialog_movimenti" width="1200">
          <v-card>
            <v-card-title class="grey--text text-subtitle-1">
              <v-icon color="blue" class="mr-2">mdi-swap-vertical</v-icon>
              Movimenti: {{ fito.dettagli.prodotto }}
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-5">
              <v-row>
                <v-col cols="4">
                  <v-select
                    :items="anni"
                    v-model="anno_rif"
                    outlined
                    label="Anno Riferimento"
                    prepend-inner-icon="mdi-calendar"
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="6">
                  <div class="d-flex align-center mb-2">
                    <v-icon color="green" class="mr-2">mdi-arrow-up-bold-box-outline</v-icon>
                    <span class="text-subtitle-2">Carico</span>
                    <v-spacer />
                    <v-chip small outlined color="green"
                      >Tot. {{ totale_movimenti_carico.toFixed(1) }} Kg/Lt.</v-chip
                    >
                  </div>
                  <v-divider class="mb-2" />
                  <template v-if="movimenti_carico.length">
                    <template v-for="carico in movimenti_carico">
                      <MovimentoCarico
                        :movimento_carico="carico"
                        :id_prodotto="fito.id_fitofarmaco"
                        :key="carico.id"
                      />
                      <v-divider :key="carico.id + '-div'" class="my-2" />
                    </template>
                  </template>
                  <div v-else class="text-center grey--text text-caption py-6">
                    Nessun carico registrato nel {{ anno_rif }}
                  </div>
                </v-col>
                <v-col cols="6">
                  <div class="d-flex align-center mb-2">
                    <v-icon color="red" class="mr-2">mdi-arrow-down-bold-box-outline</v-icon>
                    <span class="text-subtitle-2">Scarico</span>
                    <v-spacer />
                    <v-chip small outlined color="red"
                      >Tot. {{ totale_movimenti_scarico.toFixed(1) }} Kg/Lt.</v-chip
                    >
                  </div>
                  <v-divider class="mb-2" />
                  <template v-if="movimenti_scarico.length">
                    <template v-for="scarico in movimenti_scarico">
                      <MovimentoScarico
                        :movimento_scarico="scarico"
                        :id_prodotto="fito.id_fitofarmaco"
                        :key="scarico.id"
                      />
                      <v-divider :key="scarico.id + '-div'" class="my-2" />
                    </template>
                  </template>
                  <div v-else class="text-center grey--text text-caption py-6">
                    Nessuno scarico registrato nel {{ anno_rif }}
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="dialog_movimenti = false"
                >Chiudi</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_carico" width="600">
          <v-card>
            <v-card-title class="grey--text text-subtitle-1">
              <v-icon color="green" class="mr-2"
                >mdi-arrow-up-bold-box-outline</v-icon
              >
              Carico Fitofarmaco
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-5">
              <v-row>
                <v-col>
                  <v-autocomplete
                    :items="fornitori"
                    v-model="id_fornitore"
                    label="Fornitore"
                    item-value="id"
                    item-text="nome"
                    outlined
                    hide-details
                  />
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-dialog
                    ref="dialog"
                    v-model="dialog_data"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date"
                        label="Data di Carico"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" scrollable locale="IT">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog_data = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="qta_carico"
                    outlined
                    label="Quantità Caricata"
                    suffix="Kg/lt."
                    type="number"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="dialog_carico = false"
                >Chiudi</v-btn
              >
              <v-btn
                outlined
                color="green"
                @click="aggiungi_movimemnto()"
                :disabled="!id_fornitore || !date || !qta_carico"
                :loading="loading_invio"
                ><v-icon class="mr-2">mdi-arrow-up</v-icon>Carica</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-tooltip top v-if="hover">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="green"
              class="mr-2 my-n2"
              small
              v-bind="attrs"
              v-on="on"
              @click="dialog_carico = true"
              ><v-icon>mdi-arrow-up</v-icon></v-btn
            >
          </template>
          <span>Carica prodotto</span>
        </v-tooltip>
        <!-- Dialog Scarico -->

        <v-dialog v-model="dialog_scarico" width="600">
          <v-card>
            <v-card-title class="grey--text text-subtitle-1">
              <v-icon color="red" class="mr-2"
                >mdi-arrow-down-bold-box-outline</v-icon
              >
              Scarico Fitofarmaco
            </v-card-title>
            <v-divider />
            <v-card-text class="pt-5">
              <v-row>
                <v-col>
                  <v-dialog
                    ref="dialog"
                    v-model="dialog_data"
                    :return-value.sync="date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="date"
                        label="Data di Scarico"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                        hide-details
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="date" scrollable locale="IT">
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="dialog_data = false">
                        Cancel
                      </v-btn>
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dialog.save(date)"
                      >
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    v-model="qta_scarico"
                    outlined
                    label="Quantità Scaricata"
                    suffix="Kg/lt."
                    type="number"
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field
                    outlined
                    label="Motivo dello scarico"
                    v-model="motivo_scarico"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="dialog_scarico = false"
                >Chiudi</v-btn
              >
              <v-btn
                outlined
                color="green"
                @click="aggiungi_movimemnto_scarico()"
                :disabled="!motivo_scarico || !qta_scarico"
                :loading="loading_invio"
                ><v-icon class="mr-2">mdi-arrow-down</v-icon>Scarica</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-tooltip top v-if="hover">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              class="mr-2 my-n2"
              small
              v-bind="attrs"
              v-on="on"
              @click="dialog_scarico = true"
              ><v-icon>mdi-arrow-down</v-icon></v-btn
            >
          </template>
          <span>Scarica prodotto</span>
        </v-tooltip>
        <v-menu v-model="menu_delete" :close-on-content-click="false">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              color="red"
              class="mr-2 my-n2"
              small
              v-show="hover"
              v-bind="attrs"
              v-on="on"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </template>
          <v-card width="320">
            <v-card-title class="red--text">
              <v-icon color="red" class="mr-2">mdi-alert-circle-outline</v-icon>
              Elimina fitofarmaco
            </v-card-title>
            <v-card-text>
              Sei sicuro di voler eliminare
              <b>{{ fito.dettagli.prodotto }}</b> dal magazzino? L'operazione
              non è reversibile.
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn text color="grey" @click="menu_delete = false"
                >Annulla</v-btn
              >
              <v-btn
                outlined
                color="red"
                :loading="loading_elimina"
                @click="elimina_fitofarmaco()"
                ><v-icon class="mr-2">mdi-delete</v-icon>Elimina</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
      <v-snackbar color="red" top v-model="no_delete"
        ><v-icon class="mr-2">mdi-alert</v-icon> Impossibile
        eliminare. Il prodotto è usato in un evento</v-snackbar
      >
    </v-row>
  </v-hover>
</template>

<script>
import fito_element_mixin from "../mixin/fitofarmaco_element_mixin";
import MovimentoCarico from "./fitofarmaco_movimento_carico_element.vue";
import MovimentoScarico from "./fitofarmaco_movimento_scarico_element.vue";
export default {
  components: {
    MovimentoCarico,
    MovimentoScarico,
  },
  mixins: [fito_element_mixin],
};
</script>